import { Capacitor } from '@capacitor/core'
import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings'

export const openAppSettings = (androidOption?: AndroidSettings, iosOption?: IOSSettings) => {
  if (Capacitor.isNativePlatform()) {
    /**
     * Note that the only supported option by Apple is "App".
     * Using other options might break in future iOS versions
     * or have your app rejected from the App Store.
     */
    NativeSettings.open({
      optionAndroid: androidOption ?? AndroidSettings.ApplicationDetails,
      optionIOS: iosOption ?? IOSSettings.App,
    })
  }
}
